import { render, staticRenderFns } from "./AdminGlobalOverview.vue?vue&type=template&id=e2a8f74e&scoped=true"
import script from "./AdminGlobalOverview.vue?vue&type=script&lang=js"
export * from "./AdminGlobalOverview.vue?vue&type=script&lang=js"
import style0 from "./AdminGlobalOverview.vue?vue&type=style&index=0&id=e2a8f74e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a8f74e",
  null
  
)

export default component.exports